"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var emotion_1 = require("emotion");
var placeholder_icon_1 = require("../../../../svg/placeholder.icon");
var core_components_1 = require("@securityproducts/core-components");
var historicalReportPlaceholder_i18n_1 = require("./historicalReportPlaceholder.i18n");
function HistoricalReportsPlaceholder(props) {
    var strings = core_components_1.useLocalisation(historicalReportPlaceholder_i18n_1.historicalReportPlaceholderTranslations, props.language);
    return (React.createElement("div", { className: "" + exports.placeholder },
        React.createElement(placeholder_icon_1.PlaceholderIcon, { id: "placeholder" }),
        React.createElement("p", { id: "no-selection" }, strings.selectAnAgent)));
}
exports.HistoricalReportsPlaceholder = HistoricalReportsPlaceholder;
exports.placeholder = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: Noto Regular;\n    text-align: center;\n    font-size: 18px;\n    & img {\n        padding-top: 50px;\n    }\n    & p {\n        padding-top: 40px;\n    }\n"], ["\n    font-family: Noto Regular;\n    text-align: center;\n    font-size: 18px;\n    & img {\n        padding-top: 50px;\n    }\n    & p {\n        padding-top: 40px;\n    }\n"])));
var templateObject_1;
